import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Observable, Subject, combineLatest, of } from 'rxjs'
import { map, switchMap, takeUntil } from 'rxjs/operators'

import { LaskunAsiakas } from '@lemon/core-firebase/model/lasku'
import { LaskuUriService } from '@lemon/core-firebase/service/lasku/lasku-uri.service'

import { AsiakasService } from 'app/_angular/service/asiakas/asiakas.service'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonator.service'
import { Asiakas } from 'app/_jaettu-lemonator/model/asiakas'

@Component({
  templateUrl: './lasku-asiakas-selaa.katsele.component.html',
  styleUrls: ['./lasku-asiakas-selaa.katsele.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuAsiakasSelaaKatseleComponent implements OnInit, OnDestroy {
  private _ngUnsubscribe = new Subject<void>()

  readonly asiakas = signal<Asiakas | null>(null)
  laskunAsiakasObservable: Observable<LaskunAsiakas | null>

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _asiakasService: AsiakasService,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _laskuUriService: LaskuUriService,
  ) {
    this.laskunAsiakasObservable = combineLatest([this._asiakasService.nykyinenAsiakasAvainObservable, this._route.paramMap]).pipe(
      switchMap(([avainTiedot, params]) => {
        const laskunAsiakasAvain = params.get('laskunAsiakasAvain')
        if (!avainTiedot?.avain || !laskunAsiakasAvain) {
          return of<LaskunAsiakas | null>(null)
        }
        const uri = this._laskuUriService.getLaskuAsiakasUri(avainTiedot.avain, laskunAsiakasAvain)
        return this._firebaseLemonaid
          .firestoreDoc<LaskunAsiakas>(uri)
          .listen()
          .pipe(
            map(doc => {
              if (!doc) {
                return null
              }
              doc.avain = laskunAsiakasAvain
              return doc
            }),
          )
      }),
    )
  }

  ngOnInit() {
    this._asiakasService.nykyinenAsiakasObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(asiakas => {
      this.asiakas.set(asiakas)
    })
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  takaisin() {
    if (!this.asiakas()?.avain) {
      return
    }
    this._router.navigate(['asiakkaat', this.asiakas().avain, 'lasku-asiakkaat', 'selaa'])
  }
}
